import { RemoteApiErrorSeverity } from './remote-api-error-severity.enum';

export class RemoteApiErrorMessage {
  public static fromJSON(json: any): RemoteApiErrorMessage {
    // TODO: Enhance for the setting of messageParameters & errorParameters
    return new RemoteApiErrorMessage(
      json.key,
      json.severity,
      json.defaultDescription,
      json.message,
      [],
      {},
      []
    );
  }

  constructor(
    public readonly key: string,
    public readonly severity: RemoteApiErrorSeverity,
    public readonly defaultDescription: string,
    public readonly message: string | null,
    public readonly messageParameters: Array<string | number | boolean> | null,
    public readonly errorParameters: object | null,
    public readonly args: Array<string | number | boolean> | null
  ) {}
}
